export default __webpack_public_path__ + "static/media/Trace of Fumes.20d92078.png";